import React from 'react';
import classNames from 'classnames';
import { makeStyles } from "../../../../index";
import { NoteSort } from '@smile-next/api/lib/note';
import { NoteSelectCard } from "../../../../components/NoteSelect/NoteSelectCard";
import { pathToPageEditor, pathToPageEditorFrontPage } from "../../../../helpers/route-helpers";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'flex-start',
        maxWidth: 992,
    },
    card: {
        margin: theme.spacing(0.5),
    },
    dummyCard: {
        width: 240,
        height: 0,
        opacity: 0,
    },
}); });
/**
 * 1行で横に並ぶ最大カード数
 */
var MAX_CARDS_PER_ROW = 4;
/**
 * `開く`をクリックした時に開くタブのURLを指定する
 */
var openLink = function (note, showFlagPage) {
    var pageId = note.getThumbnailPageId(showFlagPage);
    return pageId ? pathToPageEditor(note.id, pageId) : pathToPageEditorFrontPage(note.id);
};
/**
 * ノートカード一覧コンポーネント
 */
export var NoteCards = function (props) {
    var notes = props.notes, selectedNoteId = props.selectedNoteId, showOwnerName = props.showOwnerName, showFlagPage = props.showFlagPage, onSelectNote = props.onSelectNote;
    var classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        notes.map(function (note) {
            return (React.createElement("div", { className: classes.card, key: note.id },
                React.createElement(NoteSelectCard, { note: note, selected: selectedNoteId.includes(note.id), sort: NoteSort.CreatedDatetime, isMultipuleSelection: true, showOwnerName: showOwnerName, thumbnailLink: note.getThumbnail(showFlagPage), openLink: openLink(note, showFlagPage), key: note.id, onSelectNote: onSelectNote })));
        }),
        Array.from(Array(MAX_CARDS_PER_ROW - 1), function (_, k) { return (
        // 最後の行のカードを左に寄せるためのダミーカード
        React.createElement("div", { className: classNames(classes.card, classes.dummyCard), key: k })); })));
};
